module.exports = __webpack_public_path__ + "media/images/tip-man-yellow-ring-ee5fd33af01a7c39ad6265569d5b158b.svg";